import React, { useContext, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
// import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Navbar from "./Components/Navbar";
import Sidebar from "./Components/Sidebar";
import Home from "./Pages/Home/Home";
// import HomeBaseline from "./Pages/Home/HomeBaseline";
// import HomeScenario from "./Pages/Home/HomeScenario";
import Compare from "./Pages/Compare/Compare";
import ManufacturingMaster from "./Pages/ManufacturingMaster/ManufacturingMaster";
import NutManufacturingMaster from "./Pages/NutritionManufacturingMaster/NutritionManufacturingMaster";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import Home2 from "./Pages/Home2/Home2";
import Home3 from "./MediumTerm/HomeCare/Home2/Home3";
import ShiftAndChangeover from "./Pages/ShiftAndChangeover/ShiftAndChangeover";
import NutShiftAndChangeover from "./Pages/NutritionShiftAndChangeover/NutritionShiftAndChangeover";
import LandedCost from "./Pages/LandedCost/LandedCost";
import Flows from "./Pages/Flows/Flows";
import MediumFlows from "./MediumTerm/Flows/Flows";
import OEEAndCPTInputs from "./Pages/OEEAndCPT/OEEAndCPT";
import ManufactureOPEAndCPTInputs from "./Pages/ManufacturingOPEandCPT/OEEAndCPT";
import PackagingOEEAndCPTInputs from "./Pages/PackagingOEEandCPT/OEEAndCPT";
import PackagingMaster from "./Pages/PackagingMaster/PackagingMaster";
import MediumManufacturingMaster from "./MediumTerm/HomeCare/ManufacturingMaster/ManufacturingMaster";
import MediumShiftAndChangeover from "./MediumTerm/HomeCare/ShiftAndChangeover/ShiftAndChangeover";
import MediumLandedCost from "./MediumTerm/HomeCare/LandedCost/LandedCost";
import MediumOEEAndCPTInputs from "./MediumTerm/HomeCare/OEEAndCPT/OEEAndCPT";
import MediumNutritionManufacturingMaster from "./MediumTerm/Nutrition/NutritionManufacturingMaster/NutritionManufacturingMaster";
import MediumPackagingMaster from "./MediumTerm/Nutrition/PackagingMaster/PackagingMaster";
import MediumNutritionShiftAndChangeover from "./MediumTerm/Nutrition/NutritionShiftAndChangeover/NutritionShiftAndChangeover";
import MediumManufactureOPEAndCPTInputs from "./MediumTerm/Nutrition/ManufacturingOPEandCPT/OEEAndCPT";
import MediumPackagingOEEAndCPTInputs from "./MediumTerm/Nutrition/PackagingOEEandCPT/OEEAndCPT";
import MediumCompare from "./MediumTerm/HomeCare/Compare/Compare";
// import Landing from "./Pages/Landing/Landing";
import Landingv2 from "./Pages/Landing/Landingv2";
import CGOHome from "./Pages/CGOHome/CGOHome";
import CGOFlows from "./Pages/CGOFlows/CGOFlows";
// import LongFlows from "./Pages/LongTerm/Flows/CGOFlows";

import CGOSidebar from "./Components/CGOSidebar";
import Demand from "./Pages/Demand/Demand";
import ExistingPlanet from "./Pages/ExistingPlanet/ExistingPlanet";

import LongTermSidebar from "./Components/LongTermSidebar";
import LongTermHome from "./Pages/LongTerm/LongTermHome";
import CascadeMaster from "./Pages/LongTerm/CascadeMaster/CascadeMaster";
import FacilityMaster from "./Pages/LongTerm/FacilityMaster/FacilityMaster";
import ProcessingPlant from "./Pages/LongTerm/ProcessingPlant/ProcessingPlant";
import Procurement from "./Pages/LongTerm/Procurement/Procurement";
import RMTransportation from "./Pages/LongTerm/RMTransportation/RMTransportation";
import DynamicConstrains from "./Pages/LongTerm/DynamicConstrains/DynamicConstrains";
import PackagingPlantMaster from "./Pages/LongTerm/PackagingPlant/PackagingPlant";
import PrimaryTransportation from "./Pages/LongTerm/PrimaryTransportation/PrimaryTransportation";
import LongTermFlows from "./Pages/LongTerm/Flows/LongTermFlows";
import SFGTransportation from "./Pages/LongTerm/SFGTransportation/SFGTransportation";
import LTCompare from "./Pages/LongTerm/Compare/Compare";
import LTDemand from "./Pages/LongTerm/Demand/LTDemand";
import FGBom from "./Pages/LongTerm/FGBom/FGBom";
import SFGBom from "./Pages/LongTerm/SFGBom/SFGBom";
import {
  MsalAuthenticationTemplate,
  useAccount,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";

import { MsalProvider } from "@azure/msal-react";
import { InteractionType, InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "./Services/auth-config";
import axios from "axios";
import { EventType } from "@azure/msal-browser";
import { loginUserDetails, setApiUserData } from "./Redux/Actions/InputData";
import RMLandedCost from "./Pages/LongTerm/RMLandedCost/RMLandedCost";
import RMMILandedCost from "./Pages/LongTerm/RMMILandedCost/RMMILandedCost";
import RMPMProcurement from "./Pages/LongTerm/RMPMProcurement/RMPMProcurement";
import RMPMTransportation from "./Pages/LongTerm/RMPMTransportation/RMPMTransportation";
import { API_BASE_URL, USERBY_EMAIL } from "./Utils/Config";
import { postRequest } from "./Services/AxiosConfiguration";

function App({ msalInstance }: any) {
  const [useInfo, setUserInfo] = useState<any>({});
  const dispatch: any = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [getAccountId, setAccountId] = useState("");
  const [isUserVerified, setIsUserVerified] = useState<null | boolean>(null);

  const authRequest = {
    ...loginRequest,
  };

  const verifyUserByEmail = async (email: string) => {
    try {
      const urls = API_BASE_URL + USERBY_EMAIL;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      postRequest(urls, {}, header, { emailId: email })
        .then((response: any) => {
          if (response.status === 200 && response.data) {
            console.log(response.data[0]?.isActive, "responseresponse");
            setIsUserVerified(response.data[0]?.isActive);
            dispatch(setApiUserData(response.data[0]));
          }
        })
        .catch((error: any) => {
          console.log(error);
          setIsUserVerified(false);
        });
    } catch (err) {
      console.error("Error verifying user by email", err);
      setIsUserVerified(false);
    }
  };

  function MsalAppContent(props: any) {
    const { inProgress } = useMsal();

    if (inProgress !== InteractionStatus.None) {
      return <div style={{ padding: 40, textAlign: "center" }}>Loading...</div>;
    }

    return (
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={props.authRequest}
      >
        {isUserVerified === null ? (
          <div style={{ padding: 40, textAlign: "center" }}>Loading...</div>
        ) : isUserVerified ? (
          (!showModal || window.location.href.includes("-p-")) && <Pages />
        ) : (
          <NotAuthorized />
        )}
      </MsalAuthenticationTemplate>
    );
  }
  const NotAuthorized = () => (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h2>Access Denied</h2>
      <p>Your account is not authorized to use this application.</p>
      <p>Please contact your administrator.</p>
    </div>
  );
  useEffect(() => {
    const callbackId = msalInstance.addEventCallback((event: any) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload.account
      ) {
        let userData: any = {};
        const account = event.payload.account;

        userData.name = account.name;
        userData.userName = account.username;

        setUserInfo(userData);
        dispatch(loginUserDetails(userData));

        msalInstance.setActiveAccount(account);
        localStorage.setItem("userDetails", JSON.stringify(account));

        setIsUserVerified(null); // show "Checking access..."
        verifyUserByEmail(account.username);
      }
    });

    // get account id
    const currentAccounts = msalInstance.getAllAccounts();
    if (!currentAccounts || currentAccounts.length < 1) {
      return;
    } else if (currentAccounts.length === 1) {
      const activeAccount = currentAccounts[0];
      msalInstance.setActiveAccount(activeAccount);
      const accountId = activeAccount.homeAccountId;
      setAccountId(accountId);
      localStorage.setItem("accountHomeId", accountId);

      setIsUserVerified(null);
      verifyUserByEmail(activeAccount.username);
    }

    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, [msalInstance, dispatch]);

  const { inProgress } = useMsal();

  if (inProgress !== InteractionStatus.None) {
    return <div>Authenticating...</div>;
  }
  return (
    <>
      <MsalProvider instance={msalInstance}>
        <MsalAppContent
          showModal={showModal}
          setShowModal={setShowModal}
          getAccountId={getAccountId}
          setAccountId={setAccountId}
          isUserVerified={isUserVerified}
          setIsUserVerified={setIsUserVerified}
          verifyUserByEmail={verifyUserByEmail}
          authRequest={authRequest}
          dispatch={dispatch}
          msalInstance={msalInstance}
        />
      </MsalProvider>
    </>
  );
}

const Pages = () => {
  const selectCGOInput = localStorage.getItem("selectCGOInput");
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );
  const currentPath = window.location.pathname;

  return (
    <div className="App">
      {currentPath !== "/" ? <Navbar /> : ""}
      <Grid container spacing={1}>
        {currentPath !== "/" ? (
          <div className="sidebar-map">
            {selectCGOInput === "CGOInput" ? (
              <CGOSidebar />
            ) : selectCGOInput === "LongTermInput" ? (
              <LongTermSidebar />
            ) : (
              <Sidebar />
            )}
          </div>
        ) : (
          ""
        )}
        <div className="map-area">
          <Routes>
            <Route path="/" element={<Landingv2 />} />
            <Route
              path="/Home"
              element={selectedUsecaseId === 1 ? <Home2 /> : <Home3 />}
            />
            <Route path="/CGOHome" element={<CGOHome />} />
            <Route path="/LongTermHome" element={<LongTermHome />} />
          </Routes>
        </div>
        <div className="content-area">
          <Routes>
            <Route
              path="/compare"
              element={
                selectedUsecaseId === 1 ? <Compare /> : <MediumCompare />
              }
            />
            <Route
              path="/manufacturemaster"
              element={
                selectedUsecaseId === 1 ? (
                  <ManufacturingMaster />
                ) : (
                  <MediumManufacturingMaster />
                )
              }
            />
            <Route
              path="/nutmanufacturemaster"
              element={
                selectedUsecaseId === 1 ? (
                  <NutManufacturingMaster />
                ) : (
                  <MediumNutritionManufacturingMaster />
                )
              }
            />
            <Route
              path="/shiftchangeover"
              element={
                selectedUsecaseId === 1 ? (
                  <ShiftAndChangeover />
                ) : (
                  <MediumShiftAndChangeover />
                )
              }
            />
            <Route path="/demand" element={<Demand />} />
            <Route path="/existingplanet" element={<ExistingPlanet />} />
            <Route
              path="/nutshiftchangeover"
              element={
                selectedUsecaseId === 1 ? (
                  <NutShiftAndChangeover />
                ) : (
                  <MediumNutritionShiftAndChangeover />
                )
              }
            />
            <Route
              path="/packagingmaster"
              element={
                selectedUsecaseId === 1 ? (
                  <PackagingMaster />
                ) : (
                  <MediumPackagingMaster />
                )
              }
            />
            <Route
              path="/landedcost"
              element={
                selectedUsecaseId === 1 ? <LandedCost /> : <MediumLandedCost />
              }
            />
            <Route
              path="/flows"
              element={selectedUsecaseId === 1 ? <Flows /> : <MediumFlows />}
            />
            <Route path="/CGOflows" element={<CGOFlows />} />
            <Route
              path="/oeeandcpt"
              element={
                selectedUsecaseId === 1 ? (
                  <OEEAndCPTInputs />
                ) : (
                  <MediumOEEAndCPTInputs />
                )
              }
            />
            <Route
              path="/manufacturingopeandcpt"
              element={
                selectedUsecaseId === 1 ? (
                  <ManufactureOPEAndCPTInputs />
                ) : (
                  <MediumManufactureOPEAndCPTInputs />
                )
              }
            />
            <Route
              path="/packagingoeeandcpt"
              element={
                selectedUsecaseId === 1 ? (
                  <PackagingOEEAndCPTInputs />
                ) : (
                  <MediumPackagingOEEAndCPTInputs />
                )
              }
            />
            <Route path="/facilityMaster" element={<FacilityMaster />} />
            <Route path="/cascadeMaster" element={<CascadeMaster />} />
            <Route path="/procurement" element={<Procurement />} />
            <Route path="/rmTransportation" element={<RMTransportation />} />
            <Route path="/rmlandedcost" element={<RMLandedCost />} />
            <Route path="/rmpmprocurement" element={<RMPMProcurement />} />
            <Route
              path="/rmpmtransportation"
              element={<RMPMTransportation />}
            />
            <Route path="/rmmilandedCost" element={<RMMILandedCost />} />
            <Route path="/processingPlant" element={<ProcessingPlant />} />
            <Route path="/LongTermflows" element={<LongTermFlows />} />
            <Route path="/dynamicconstrains" element={<DynamicConstrains />} />
            <Route path="/facilityMaster" element={<FacilityMaster />} />
            <Route path="/cascadeMaster" element={<CascadeMaster />} />
            <Route path="/packagingPlant" element={<PackagingPlantMaster />} />
            <Route path="/SFGTransportation" element={<SFGTransportation />} />
            <Route
              path="/primaryTransportation"
              element={<PrimaryTransportation />}
            />
            <Route path="/procurement" element={<Procurement />} />
            <Route path="/rmTransportation" element={<RMTransportation />} />
            <Route path="/processingPlant" element={<ProcessingPlant />} />
            <Route path="/ltCompare" element={<LTCompare />} />
            <Route path="/ltDemand" element={<LTDemand />} />
            <Route path="/fgBOM" element={<FGBom />} />
            <Route path="/sfgBOM" element={<SFGBom />} />
          </Routes>
        </div>
      </Grid>
    </div>
  );
};

export default App;
